import {applyMiddleware, combineReducers, createStore} from "redux";
import {createLogger} from "redux-logger";
import persistState from "redux-localstorage";
import createHistory from 'history/createBrowserHistory'
import {routerMiddleware} from 'react-router-redux'
import reducers from './reducers';
import zipMiddleware from './middlewares/zip'
const history = createHistory()
const router_middleware = routerMiddleware(history)
const logger = createLogger();

/**
 * This is a reducer, a pure function with (state, action) => state signature.
 * It describes how an action transforms the state into the next state.
 *
 * The shape of the state is up to you: it can be a primitive, an array, an object,
 * or even an Immutable.js data structure. The only important part is that you should
 * not mutate the state object, but return a new object if the state changes.
 *
 * In this example, we use a `switch` statement and strings, but you can use a helper that
 * follows a different convention (such as function maps) if it makes sense for your
 * project.
 */

//the store should be something like this:
//{authenticated:true/false, userData:user}
const middlewares=process.env.REACT_APP_ENV!=="PRODUCTION" ? applyMiddleware(logger, zipMiddleware, router_middleware) : applyMiddleware(zipMiddleware, router_middleware)
const store = createStore(
  combineReducers(reducers),
  middlewares,
  persistState(["user","router","accounts","stories"]))
export const ReduxConfig={store, history};
export default store;



// WEBPACK FOOTER //
// ./src/utils/store.js